module.exports = __webpack_public_path__ + "mfbcode_chinagen.png?16257883da8f2d93eadfdcfa22f9bb6d";